import request from '@/utils/request'
export function collect_info(data) {
    return request({url: 'collect_info',data});
}
export function collect_submit(data) {
    return request({url: 'collect_submit',data});
}